import React, { useState } from 'react';
import ReactTable from 'react-table'
import ReactTooltip from 'react-tooltip'
import moment from 'moment';

const KeyTable = props => {
    const columns = [{
        Header: 'NAMA',
        headerClassName: 'pl-4',
        Cell: ({row,original}) => nameCell(original)
    },{
        Header: 'KUNCI API',
        accessor: 'name',
        Cell: ({row,original}) => keyCell(original)
    },{
        Header: 'TANGGAL DIBUAT',
        accessor: 'createdAt',
        Cell: ({row,original}) => (<div className="pointer">{moment(original.createdAt).format("DD MMM YYYY, HH:mm")}</div>)
    },{
        Header: 'EDIT',
        accessor: 'edit',
        minWidth: 30,
        Cell: ({row,original}) => editCell(original)
    }];

    const nameCell = (og) => {
        return (
            <div className="pl-4 pointer">
                <text className="font-weight-bold text-darker">{og.name}</text> <br/>
                <div>ID Kunci: <b>{og.id}</b></div>
            </div>
        )
    };

    const keyCell = (og) => {
        return (
            <div className="p-2 pointer">
                <ReactTooltip/>
                <i className="fas fa-key mr-3"></i>
                <span
                    data-tip="Demi keamanan, kami tidak mengizinkan nilai kunci untuk ditampilkan "
                    style={{fontSize:18}}>
                    ••••••••••••••••••••
                </span>
            </div>
        )
    };

    const editCell = (og) => {
        return (
            <div className="actions row ml-1 pointer">
                 <ReactTooltip/>
                <a onClick={() => window.location.assign(`/integrations/api/keys/${og.id}`)}
                   className="action-item mr-2"
                   data-tip="Detail Penggunaan Kunci "
                   data-toggle="tooltip"
                   title="Usage"
                >
                    <i className="fas fa-chart-bar text-lg mt-1"></i>
                </a>
                <a onClick={() => onRemoveKey(og)}
                   className="action-item mr-2"
                   data-toggle="tooltip"
                   data-tip="Buang Kunci "
                   title="Trash"
                >
                    <i className="fas fa-trash"></i>
                </a>
            </div>
        )
    };

    const onRemoveKey = (og) => {
        props.onDeleteToken(og.id);
    };

    return (
        <div>
            <ReactTable
                data={props.data}
                columns={columns}
                defaultPageSize={props.data.length}
                loading={props.loading}
                showPagination={false}
                className="-striped -highlight"
            />
        </div>
    )
};

export default KeyTable;
